import './userDepositHistory.css';
import React, { useState, useEffect } from 'react';
// import './Dashboard.css';
import { Avatar, Box, Button, Grid2, Tab } from '@mui/material';
import Header from '../Header/Header';
import Pagination from '@mui/material/Pagination';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import consts from "../../constant";
import Axios from "axios";
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ToastContainer, toast } from "react-toastify";
import usercalls from "../../Axios";
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import { Tooltip } from "@mui/material";



const drawerWidth = 260;
const UserDepositHistory = () => {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const theme = useTheme();
    const lg = useMediaQuery(theme.breakpoints.up('lg'));

    const Navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setloading] = useState(true);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPages] = useState(0)
    const itemsPerPage = 10

    const path = usercalls()



    const withdrawDetails = async () => {
        try {
            setloading(true);
            const url = `${consts.BackendUrl}/admin/depositDetails`;
            const response = await path.postCall({ url });
            const result = await response.json();
            console.log(result, 'result');
            if (result?.success) {
                setData(result?.result);
                setloading(false);
                setTotalPages(Math.ceil(result?.result.length / limit));
            }
        } catch (error) {
            console.log(error, 'errors');
        }
    };

    useEffect(() => {
        if (localStorage.getItem("adminToken")) {
            withdrawDetails()
        } else {
            Navigate(`/${consts.route + '/login'}`);
        }
    }, [limit, page]);


    const [reason, setReason] = useState("")

    const [selcId, setSelcId] = useState("")

    const handleUpdate = async (val, type) => {
        console.log(val, type, "74545444444")
        try {

            let payload = {}
            if (type == "approved") {
                payload = {
                    id: val,
                    status: type,
                    reason: "Your withdraw is Approved by Admin",
                }
            } else {
                payload = {
                    id: val,
                    status: type,
                    reason: "Your withdraw is Rejected by Admin",
                }
            }

            const url = `${consts.BackendUrl}/wallet/updateWithdrawStatus`
            const response = await path.postCall({ url, payload })
            const result = await response.json()
            console.log(result, 'result');
            if (result?.success) {
                toast.success(result?.message)
                withdrawDetails()

            }
        } catch (error) {
            console.log("🚀 ~ handleUpdate ~ error:", error)
        }

    }






    const array = ["S.no", "Name", "Email", "Asset Name", "Address", "Transaction Id", "Amount", "Status",];

    return (
        <div className="UserDepositHistory">
            <ToastContainer />
            <Box sx={{ display: lg ? 'flex' : 'block' }}>
                <Header />
                <Box
                    component="main"
                    sx={{ flexGrow: 1, p: 5, width: { lg: `calc(100% - ${drawerWidth}px)` }, marginTop: '50px' }}
                >
                    <h2 style={{ color: "#fff" }}>Users Deposit History</h2>
                    <Grid2 container spacing={2}>

                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <div className="custom_table">
                                <TableContainer>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                {array.map((val, index) => (
                                                    <TableCell align="center" key={index}>
                                                        {val}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {data
                                                .slice((page - 1) * limit, page * limit)
                                                .map((value, index) => (
                                                    <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                        <TableCell component="th" scope="row">
                                                            {limit * (page - 1) + index + 1}
                                                        </TableCell>
                                                        <TableCell align="center">{value?.user_id?.name || '-'}</TableCell>
                                                        <TableCell align="center">{value?.user_id?.email || '-'}</TableCell>
                                                        <TableCell align="center">{value?.currency || '-'}</TableCell>
                                                        {/* <TableCell align="center">{value?.address || '-'}</TableCell> */}
                                                        <TableCell align="center">
                                                            <Tooltip
                                                                title={value?.address || '-'}
                                                                arrow
                                                                placement="top"
                                                                componentsProps={{
                                                                    tooltip: {
                                                                        sx: {
                                                                            backgroundColor: "purple",
                                                                            color: "white",
                                                                            fontSize: "14px",
                                                                            fontWeight: "bold",
                                                                            padding: "6px 12px"
                                                                        }
                                                                    },
                                                                    arrow: {
                                                                        sx: {
                                                                            color: "purple"
                                                                        }
                                                                    }
                                                                }}
                                                            >
                                                                <span style={{
                                                                    display: "block",
                                                                    whiteSpace: "nowrap",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    maxWidth: "250px"
                                                                }}>
                                                                    {value?.address || '-'}
                                                                </span>
                                                            </Tooltip>
                                                        </TableCell>
                                                        {/* <TableCell align="center">{value?.transaction_id || '-'}</TableCell> */}
                                                        <TableCell align="center">
                                                            <Tooltip
                                                                title={value?.transaction_id || '-'}
                                                                arrow
                                                                placement="top"
                                                                componentsProps={{
                                                                    tooltip: {
                                                                        sx: {
                                                                            backgroundColor: "purple", // Violet background
                                                                            color: "white", // White text for contrast
                                                                            fontSize: "14px", // Adjust text size
                                                                            fontWeight: "bold",
                                                                            padding: "6px 12px" // Adjust padding
                                                                        }
                                                                    },
                                                                    arrow: {
                                                                        sx: {
                                                                            color: "purple" // Match arrow color with tooltip
                                                                        }
                                                                    }
                                                                }}
                                                            >
                                                                <span style={{
                                                                    display: "block",
                                                                    whiteSpace: "nowrap",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    maxWidth: "250px"  // Adjust width as needed
                                                                }}>
                                                                    {value?.transaction_id || '-'}
                                                                </span>
                                                            </Tooltip>
                                                        </TableCell>
                                                        <TableCell align="center">{value?.amount || '-'}</TableCell>

                                                        <TableCell align="center">
                                                            {value?.status === "1" ? (
                                                                <CheckCircleOutlineOutlinedIcon sx={{ fill: "green" }} />
                                                            ) : (
                                                                <BlockOutlinedIcon sx={{ fill: "red" }} />
                                                            )}
                                                        </TableCell>


                                                        {/* 
                                                        <TableCell
                                                            align="center"
                                                            sx={{ color: value?.status === "1" ? "green" : value?.status === "2" ? "red" : "black" }}
                                                        >
                                                            {value?.status === "1"
                                                                ? "Success"
                                                                : value?.status === "2"
                                                                    ? "Failed"
                                                                    : "-"}
                                                        </TableCell> */}

                                                        {/* <TableCell align="center">{value?.walletDetails?.type || '-'}</TableCell>
                                                        <TableCell align="center" style={{ display: 'flex', gap: '10px' }}>
                                                            {value?.status === 'pending' ? (
                                                                <div className="display-1">
                                                                    <Button variant="contained" color="success" onClick={() => handleUpdate(value?._id, 'approved')}>
                                                                        Approve
                                                                    </Button>
                                                                    <Button variant="contained" color="error" onClick={() => handleUpdate(value?._id, 'declined')}>
                                                                        Decline
                                                                    </Button>
                                                                </div>
                                                            ) : (
                                                                <Button
                                                                    style={{ width: '100%' }}
                                                                    variant="contained"
                                                                    color={value?.status === 'approved' ? 'success' : 'error'}
                                                                >
                                                                    {value?.status}
                                                                </Button>
                                                            )}
                                                        </TableCell> */}
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <Pagination
                                    className="pagnation"
                                    count={totalPage}
                                    page={page}
                                    onChange={(event, value) => {
                                        setPage(value);
                                    }}
                                    shape="rounded"
                                />
                            </div>
                        </Grid2>
                    </Grid2>
                </Box>
            </Box>
        </div >
    );
};

export default UserDepositHistory;
